export default {
  name: 'jobs',
  list: 'list',
  notifications: 'notifications'
};
